var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvertising(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 52 52",
    enableBackground: "new 0 0 52 52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,27.2c0.1,0,0.3,0,0.4,0c0.2-2.7,1.2-5.1,2.7-7c-0.8-0.8-1.8-1.3-3.1-1.3c-2.4,0-4.2,1.8-4.2,4.2 C18.8,25.4,20.6,27.2,23,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2,35.2c0.5,0,1-0.1,1.2-0.1c-0.8-1.3-1.4-2.7-1.7-4c-0.2,0-0.5,0-0.7,0c-4.5,0-8.4-3.6-8.4-8.4 c0-4.5,3.6-8.4,8.4-8.4c2.5,0,4.9,1.1,6.4,2.9c1.2-0.7,2.5-1.1,3.9-1.3c-2.3-3.3-6.1-5.4-10.4-5.4c-7.2,0-12.6,5.7-12.6,12.6 s5.7,12.6,12.9,12.3C23.6,35.3,23.9,35.3,24.2,35.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.9,45.5v1.4c0,1.6-1.4,3-3,3H22.8c-1.6,0-3-1.4-3-3v-1.4c0-3.6,4.3-5.9,8.3-7.7l0.4-0.2 c0.3-0.1,0.6-0.1,0.9,0.1c1.6,1.1,3.5,1.6,5.4,1.6c1.9,0,3.8-0.6,5.4-1.6c0.3-0.2,0.6-0.2,0.9-0.1l0.4,0.2 C45.7,39.6,49.9,41.8,49.9,45.5z M34.8,19.8c4.2,0,7.5,3.7,7.5,8.3s-3.3,8.3-7.5,8.3s-7.5-3.7-7.5-8.3S30.7,19.8,34.8,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,39.2c-6.9-2-12.2-8.5-12.2-16.1c0-9.3,7.5-16.8,16.8-16.8c6.9,0,13.1,4.1,15.6,10.2 c2,0.8,3.8,2.1,5.1,3.8C42.3,9.8,33.6,2.1,23,2.1C11.3,2.1,2.1,11.3,2.1,23c0,9.2,5.8,17,14.2,19.7C16.7,41.3,17.5,40.2,18.5,39.2 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertising);
export default __webpack_public_path__ + "static/media/advertising.404a008b836817b8110cbda262ac4a6a.svg";
export { ForwardRef as ReactComponent };